import React from "react";
import SEO from "../../Components/SEO";
import Breadcrumb from "../../Components/Breadcrumb";
import { ActivityLayout } from "../../Components/activity-layout";
import ActivityFilter from "../../Shared/activityFilter";
import readingcomp from "./Data/readingcomp.jsx";

const reading = '/Images/reading1-1280x470.webp';

const Readingexercises = () => {
    return (
        <ActivityLayout
            title="Reading Exercises"
            image={reading}
            intro="Improve your reading skills with our categorized practice exercises. Browse through different exam tasks including comprehension, paragraph headings, and interactive grammar identification — all organized by level."
        >
            <SEO
                title="Free English Reading Lesson Plans & Activities for ESL Teachers"
                description="Ready-to-use reading lesson plans for online ESL teachers. Texts with comprehension questions, vocabulary, and discussion activities organized by CEFR level and topic. Perfect for 1-to-1 or group classes."
                name="English Exam Exercises"
                type="article"
                image={reading}
            />
            <Breadcrumb />
            <ActivityFilter
                data={readingcomp}
                getLink={(item) => `/reading-exercises/${item.id}`}
                ctaLabel="Read Exercise"
                resultsLabel="exercises"
                itemsPerPage={6}
            />
        </ActivityLayout>
    );
};

export default Readingexercises;
